import { Box, Typography, Image, Flex } from "@jewlr/storybook/core"

import { protectionPlanData } from "areas/info/warranty//data"
import { jewlr_t } from "helpers/application"

const ProtectionPlan = () => (
  <Box
    alignItems="flex-start"
    display={{ _: "block", tablet: "flex" }}
    flexWrap="wrap"
    mb={{ _: 5, tablet: 8 }}
    textAlign="center"
  >
    <Box flex={1}>
      <Typography
        mb={2}
        p={{ _: 3, tablet: "24px 32px 0" }}
        textAlign={{ _: "centre", tablet: "left" }}
      >
        {sl.config.site_title} has partnered with Extend to offer simple,
        affordable protection plans to protect your {jewlr_t("terms.jewelry")}.
        Purchase your plan today and enhance your warranty for up to 5 years.
      </Typography>
    </Box>
    <Box flex={1}>
      <Flex
        alignItems="flex-start"
        gutter={{ _: "4px", tablet: 1 }}
        justifyContent="center"
        pb={2}
      >
        {protectionPlanData().map((plan, index) => (
          <Box key={index}>
            <Box textAlign="center">
              <Image
                alt={plan.text}
                mb={1}
                src={`${sl.config.jewlr_asset_url}images/info/warranty/${plan.icon}.jpg`}
                width="25%"
              />
              <Typography
                letterSpacing="1px"
                margin="auto"
                px={1}
                width={{ _: "95%", desktop: "70%", tablet: "80%" }}
              >
                {plan.text}
              </Typography>
            </Box>
          </Box>
        ))}
      </Flex>
    </Box>
  </Box>
)

export default ProtectionPlan
